import React, { useState, useMemo, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import DataTable from '../components/DataTable';
import {
  fetchUsers,
  fetchAddresses,
  fetchAlerts,
  fetchAudioClips,
  fetchAudioFiles,
  fetchCompanies,
  fetchCompanyAddresses,
  fetchConfigurations,
  fetchKeywords,
  fetchMatches,
  fetchPermissions,
  fetchRolePermission,
  fetchRoles,
  fetchStations,
  fetchTranscriptions,
  fetchUserAddress,
  fetchUserAlert,
  fetchUserRole,
} from '../api/apiClient';
import './../styles/dashboard.css';

const Dashboard = () => {
  const [activeEndpoint, setActiveEndpoint] = useState('users');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const endpoints = useMemo(() => [
    { id: 'users', name: 'Users', fetchFn: fetchUsers },
    { id: 'addresses', name: 'Addresses', fetchFn: fetchAddresses },
    { id: 'alerts', name: 'Alerts', fetchFn: fetchAlerts },
    { id: 'audio_clips', name: 'AudioClips', fetchFn: fetchAudioClips },
    { id: 'audio_files', name: 'AudioFiles', fetchFn: fetchAudioFiles },
    { id: 'companies', name: 'Companies', fetchFn: fetchCompanies },
    { id: 'company_addresses', name: 'CompanyAddress', fetchFn: fetchCompanyAddresses },
    { id: 'configurations', name: 'Configurations', fetchFn: fetchConfigurations },
    { id: 'keywords', name: 'Keywords', fetchFn: fetchKeywords },
    { id: 'matches', name: 'Matches', fetchFn: fetchMatches },
    { id: 'permissions', name: 'Permissions', fetchFn: fetchPermissions },
    { id: 'role_permissions', name: 'RolePermission', fetchFn: fetchRolePermission },
    { id: 'roles', name: 'Roles', fetchFn: fetchRoles },
    { id: 'stations', name: 'Stations', fetchFn: fetchStations },
    { id: 'transcriptions', name: 'Transcriptions', fetchFn: fetchTranscriptions },
    { id: 'user_addresses', name: 'UserAddress', fetchFn: fetchUserAddress },
    { id: 'user_alert', name: 'UserAlert', fetchFn: fetchUserAlert },
    { id: 'user_roles', name: 'UserRole', fetchFn: fetchUserRole },
  ], []);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const endpoint = endpoints.find((e) => e.id === activeEndpoint);
        if (endpoint) {
          const response = await endpoint.fetchFn();
          setData(response.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [activeEndpoint, endpoints]);

  return (
    <div className="dashboard">
      
      <div className="dashboard-content">
        <Sidebar
          endpoints={endpoints}
          activeEndpoint={activeEndpoint}
          onSelect={setActiveEndpoint}
        />
        <div className="dashboard-main">
          <h2>{endpoints.find((e) => e.id === activeEndpoint)?.name}</h2>
          {loading ? (
            <div>Loading...</div>
          ) : (
            <DataTable data={data} endpoint={activeEndpoint} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
